import { shortenId } from '@beamible/uuid';

// The legacy web design stores still address roles by shortened UUIDs.
function adaptSurvey(survey) {
  if (!survey?.role?.id) return survey;

  return {
    ...survey,
    role: { ...survey.role, id: shortenId(survey.role.id) },
  };
}

export default function adaptSurveyResponse(response) {
  return {
    ...response,
    data: Array.isArray(response.data)
      ? response.data.map(adaptSurvey)
      : adaptSurvey(response.data),
  };
}
